import { compose } from "redux";
import classNames from "classnames";
import { connect } from "react-redux";
import Clear from "@material-ui/icons/Clear";
import React, { PureComponent } from "react";
import { withStyles } from "@material-ui/core/styles";
import { IconButton, Tooltip } from "@material-ui/core";

import { heliReportClearRow } from "features/planner/report/report.actions";

class HeliReportClearRow extends PureComponent {
  clearRow = () => {
    const { index, type, dispatchClearRow } = this.props;
    dispatchClearRow(type, index);
  };

  render() {
    const { classes, visible } = this.props;

    return (
      <Tooltip title="Clear">
        <IconButton
          onClick={this.clearRow}
          className={classNames({
            [classes.notVisible]: !visible,
          })}
        >
          <Clear fontSize="small" />
        </IconButton>
      </Tooltip>
    );
  }
}

HeliReportClearRow.defaultProps = {
  visible: true,
};

const styles = () => ({
  notVisible: {
    visibility: "hidden",
  },
});

export default compose(
  connect(null, {
    dispatchClearRow: heliReportClearRow,
  }),
  withStyles(styles),
)(HeliReportClearRow);
